var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-color-picker',{attrs:{"size":_vm.size,"show-alpha":_vm.showAlpha,"disabled":_vm.disabledValue},model:{value:(_vm.fvalue),callback:function ($$v) {_vm.fvalue=$$v},expression:"fvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }